<template>
    <div class="c-product-data-recurring-subscription">
        <b-row>
            <b-col lg="3">
                <b-row>
                    <b-col>
                        <InputCurrency
                                class="mt-2"
                                :description="dataPaymentDescription"
                                :label="Core.Definition.getDefinition('Montant par paiement')"
                                v-model="dataValue.regularPrice"></InputCurrency>
                    </b-col>
                    <b-col>
                        <InputCheckbox
                                :label="Core.Definition.getDefinition('Taxable')"
                                v-model="dataValue.isTaxable"></InputCheckbox>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="6">

                <strong class="mt-4">
                    {{Core.Definition.getDefinition('Durée de l\'abonnement')}}
                </strong>
                <b-row class="mt-3">
                    <b-col lg="6" md="6" sm="12">
                        <InputNumber
                                :label="Core.Definition.getDefinition('Durée')"
                                v-model="dataValue.periodLength"></InputNumber>
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <InputSelect
                                :label="Core.Definition.getDefinition('Période')"
                                :options="Core.Product.periodOptions()"
                                v-model="dataValue.period"></InputSelect>
                    </b-col>
                </b-row>
                <hr/>
                <strong class="mt-4">
                    {{Core.Definition.getDefinition('Durée des paiements')}}
                </strong>
                <b-row class="mt-3">
                    <b-col lg="4" md="6" sm="12">
                        <InputSelect
                                :label="Core.Definition.getDefinition('Intervale')"
                                :options="Core.Product.periodIntervalOptions()"
                                v-model="dataValue.periodPaymentInterval"></InputSelect>
                    </b-col>
                    <b-col lg="4" md="6" sm="12">
                        <InputSelect
                                :label="Core.Definition.getDefinition('Période')"
                                :options="Core.Product.periodOptions()"
                                v-model="dataValue.periodPayment"></InputSelect>
                    </b-col>
                    <b-col lg="4" md="6" sm="12">
                        <InputNumber
                                :label="Core.Definition.getDefinition('Durée') + ' (' + dataValue.periodPayment.label + ')'"
                                :placeholder="Core.Definition.getDefinition('Durée')"
                                v-model="dataValue.periodPaymentLength"></InputNumber>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col lg="6">
                        <InputCheckbox
                                :label="Core.Definition.getDefinition('Limiter les réservations')"
                                v-model="dataValue.bookingLimitManagement"></InputCheckbox>
                    </b-col>
                </b-row>
                <b-row v-if="dataValue.bookingLimitManagement" class="mt-3">
                    <b-col>
                        <InputNumber
                                :label="Core.Definition.getDefinition('Limite de réservations')"
                                :description="Core.Definition.getDefinition('Le nombre de réservations restantes sera réinitialisé à la fin de chaque période')"
                                v-model="dataValue.bookingLimit"></InputNumber>
                    </b-col>
                    <b-col>
                        <InputSelect
                                :label="Core.Definition.getDefinition('Intervale')"
                                :options="Core.Product.periodIntervalOptions()"
                                v-model="dataValue.bookingLimitInterval"></InputSelect>
                    </b-col>
                    <b-col>
                        <InputSelect
                                :label="Core.Definition.getDefinition('Période')"
                                :options="Core.Product.periodOptions()"
                                v-model="dataValue.bookingLimitPeriod"></InputSelect>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="3">
                <strong class="mt-4">
                    {{Core.Definition.getDefinition('Résumé')}}
                </strong>
                <p class="mt-3">
                    {{resume}}
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Alert from './Alert'
    import InputSelect from './InputSelect'
    import InputDate from './InputDate'
    import InputText from './InputText'
    import InputCurrency from './InputCurrency'
    import InputCC from './InputCC'
    import InputNumber from "./InputNumber"
    import InputCheckbox from "./InputCheckbox";
    export default {
        name: 'ProductDataRecurringSubscription',
        components: {
            InputCheckbox,
            InputCurrency,
            InputSelect,
            InputText,
            InputDate,
            InputCC,
            Alert,
            InputNumber
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: function () {}
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue: {
                handler(val) {
                    this.dataPaymentDescription = Core.Text.format(Core.Definition.getDefinition('{0} {1} durant {2} {1}'), Core.Select.label(val.periodPaymentInterval, Core.Product.periodIntervalOptions()), Core.Select.label(val.periodPayment, Core.Product.periodOptions()), val.periodPaymentLength)
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        computed: {
            resume() {
                let resume = Core.Definition.getDefinition('L\'abonnement sera d\'une durée de {0} {1} et les paiements se feront {2} {3} durant {4} {5}')
                let a = this.dataValue.periodLength
                if (this.dataValue.periodPayment.label !== undefined&&this.dataValue.periodPaymentInterval.label&&this.dataValue.periodPayment.label) {
                    let b = this.dataValue.periodPayment.label.toLowerCase()
                    let c = this.dataValue.periodPaymentInterval.label.toLowerCase()
                    let d = this.dataValue.periodPayment.label.toLowerCase()
                    let e = this.dataValue.periodPaymentLength
                    return Core.Text.format(resume, a, b, c, d, e, d)
                }
                return ''
            }
        },
        mounted() {
            this.dataValue = Core.Array.newObject(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataPaymentDescription: '',
                dataValue: {
                    regularPrice: '0',
                    expirationPeriod: Core.Value.selectValue(Core.Product.periodMonth, Core.Product.periodOptions()),
                    expirationPeriodLength: '0',
                    periodLength: '0',
                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                    periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentLength: '0',
                    bookingLimitInterval: Core.Value.selectValue(Core.Product.bookingLimitInterval, Core.Product.periodIntervalOptions()),
                    bookingLimitManagement: false,
                    bookingLimit: '0',
                    attributes: [],
                    variations: [],
                    isTaxable: true,
                    ticketIsEnabled: false,
                    ticketTemplate: null
                }
            }
        },
        methods: {
        }
    }
</script>
